const DASHBOARD_DESKTOP_BREAKPOINT = 1024;

export const shouldShowSidebarInitially = (viewportWidth = (
  typeof window === "undefined" ? DASHBOARD_DESKTOP_BREAKPOINT : window.innerWidth
)) => {
  const width = Number(viewportWidth);
  return !Number.isFinite(width) || width >= DASHBOARD_DESKTOP_BREAKPOINT;
};

export default {
  isLoading: false,
  showSidebar: shouldShowSidebarInitially(),
  sidebarTriggerKey: null,
  showOffcanvas: false,
  showItemDetailOffcanvas: false,
  showHelpModal: false,
};
